module.exports = __webpack_public_path__ + "media/header_low.cf18daa5.mp4";